import { blockSlotsApi as generatedBlockSlotsApi } from '../generated/slots/blockSlots';

import { getSlotsByDayApi } from './getSlotsByDay';

const blockSlotsApi = generatedBlockSlotsApi.enhanceEndpoints({
  endpoints: {
    blockSlots: {
      invalidatesTags: (result) => result?.updated.map(({ date }) => ({ id: date, type: 'Slots' as const })) ?? [],
      onQueryStarted: async ({ body }, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;

        for (const { date } of data.updated) {
          dispatch(
            getSlotsByDayApi.util.updateQueryData('getSlotsByDay', { date }, (draft) => {
              for (const slot of draft.slots) {
                if (body.idSlots.includes(slot.slotId) && slot.type === 'freeSlot') {
                  Object.assign(slot, { type: 'blockedSlot' });
                }
              }
            }),
          );
        }
      },
    },
  },
});

export const { useBlockSlotsMutation } = blockSlotsApi;
